module.exports = __webpack_public_path__ + "img/Goals_Background.cb94a97c.png";